import React, { useMemo, useState, useEffect } from 'react';
import { ShieldAlert, Sun, Moon, Sunrise, Sunset, MessageCircle } from 'lucide-react';

interface HeroProps {
  cleanDate: string;
  onCheckInClick: () => void;
}

export const HeroSection: React.FC<HeroProps> = ({ cleanDate, onCheckInClick }) => {
  const [timeGreeting, setTimeGreeting] = useState('');

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) setTimeGreeting('Good Morning');
    else if (hour < 18) setTimeGreeting('Good Afternoon');
    else setTimeGreeting('Good Evening');
  }, []);

  const timeDiff = useMemo(() => {
    const start = new Date(cleanDate).getTime();
    const now = new Date().getTime();
    const diff = now - start;
    
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const years = Math.floor(days / 365);
    const remainingDays = days % 365;
    
    return { years, days: remainingDays, totalDays: days };
  }, [cleanDate]);

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-brand-600 to-indigo-700 rounded-3xl p-8 text-white shadow-xl">
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl"></div>

      <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            {timeGreeting}, Friend.
            {timeGreeting.includes('Morning') ? <Sunrise className="w-6 h-6" /> : <Sunset className="w-6 h-6" />}
          </h1>
          <p className="mt-2 text-brand-100 max-w-md">
            "One day at a time." You are building a life of purpose.
          </p>
        </div>

        <div className="flex flex-col items-center md:items-end">
          <div className="text-5xl font-black tracking-tight font-mono">
            {timeDiff.years > 0 && <span>{timeDiff.years}y </span>}
            <span>{timeDiff.days}d</span>
          </div>
          <div className="text-sm opacity-80 uppercase tracking-widest mt-1">Continuous Sobriety</div>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap gap-4 items-center justify-between border-t border-white/20 pt-6">
        <div className="text-sm font-medium bg-white/20 px-4 py-1.5 rounded-full backdrop-blur-sm">
          Total Days: {timeDiff.totalDays}
        </div>
        
        <div className="flex gap-3">
            <button 
                onClick={onCheckInClick}
                className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-5 py-2 rounded-full font-bold transition-all border border-white/30 backdrop-blur-sm"
            >
                <MessageCircle className="w-4 h-4" />
                Check In
            </button>
            <button 
            onClick={() => alert("SOS Protocol Initiated: Dialing Sponsor & Crisis Line...")}
            className="group flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-full font-bold transition-all shadow-lg hover:shadow-red-500/30"
            >
            <ShieldAlert className="w-4 h-4 group-hover:animate-pulse" />
            SOS
            </button>
        </div>
      </div>
    </div>
  );
};
